export default __webpack_public_path__ + "static/media/chiic.c1ff8ecf.png";